import { apiHelper } from "../../utils/apiHelper/apiHelper";
import { toast } from "react-toastify";
import {
  SITE_SETTINGS_LOADER,
  SET_SITE_SETTINGS,
  FETCH_CALCULATOR,
  FORM_SUBMITED,
  DOWNLOAD_COUNT,
} from "../actionTypes";

export const getSiteSettingData = () => async (dispatch) => {
  try {
    dispatch({
      type: SITE_SETTINGS_LOADER,
      payload: true,
    });
    const res = await apiHelper("get", "/site-setting/single");
    if (res?.data) {
      dispatch({
        type: SET_SITE_SETTINGS,
        payload: res?.data?.data,
      });
    }
    dispatch({
      type: SITE_SETTINGS_LOADER,
      payload: false,
    });
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong!");
    dispatch({
      type: SITE_SETTINGS_LOADER,
      payload: false,
    });
  }
};

export const fetchCalculatorData = () => async (dispatch) => {
  try {
    dispatch({
      type: SITE_SETTINGS_LOADER,
      payload: true,
    });
    const res = await apiHelper("get", `/calculator`);
    if (res?.data) {
      dispatch({
        type: FETCH_CALCULATOR,
        payload: res.data?.data,
      });
      dispatch({
        type: SITE_SETTINGS_LOADER,
        payload: false,
      });
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong!");
    dispatch({
      type: SITE_SETTINGS_LOADER,
      payload: false,
    });
  }
};

export const isSubscribed = (email) => async (dispatch) => {
  try {
    dispatch({
      type: SITE_SETTINGS_LOADER,
      payload: true,
    });
    const res = await apiHelper("post", "/news-letter", { email });
    if (res?.data) {
      dispatch({
        type: FORM_SUBMITED,
        payload: true,
      });
      dispatch({
        type: SITE_SETTINGS_LOADER,
        payload: false,
      });
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
    dispatch({
      type: SITE_SETTINGS_LOADER,
      payload: false,
    });
  }
};

export const updateDownloadCount = (id, param) => async (dispatch) => {
  try {
    dispatch({
      type: SITE_SETTINGS_LOADER,
      payload: true,
    });

    const res = await apiHelper(
      "get",
      `/calculator/download/${id}?countUpdate=${param}`,
    );
    if (res?.data) {
      dispatch({
        type: DOWNLOAD_COUNT,
        payload: param,
      });
      dispatch({
        type: SITE_SETTINGS_LOADER,
        payload: false,
      });
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
    dispatch({
      type: SITE_SETTINGS_LOADER,
      payload: false,
    });
  }
};
